import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { Redirect } from "react-router-dom"
import { loadingStatus, getPayload } from "../../actions"
import fieldStatus from "../../helpers/fieldStatus"
import submitData from "../../helpers/submitData"
import { Formik, Field, Form } from "formik"
import fields from "../../models/floorplan"
import * as Yup from "yup"
import NumberField from "components/NumberField"
import TextArea from "components/TextArea"
import { toast } from "react-toastify"
import Title from "../general/title"
import _ from "lodash"
import ReactSelect from "components/ReactSelect"
import settings from "settings"
import superagent from "superagent"

class AddFloorplan extends Component {
	constructor(props) {
		super(props)
		this.state = {
			ready: false,
			modal: false,
			fields: fields,
		}
	}

	validation = () => {
		return Yup.object().shape({
			name: Yup.string().required("Required"),
			feed_name: Yup.string().notRequired(""),
			feed_name_secondary: Yup.string().notRequired(),
			builder: Yup.number().required("Required"),
			sqft: Yup.number().required("Required"),
			//price: Yup.number().required("Required"),
			//stories: Yup.number().required("Required"),
			//beds: Yup.number().required("Required"),
			//full_baths: Yup.number().required("Required"),
			status: Yup.number().required("Required"),
			//garage: Yup.number().required("Required"),
		})
	}

	submitClasses = (f) => {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f,
		})

		return submitClasses
	}

	buildClassifications = () => {
		let ret = []
		_.forEach(this.props.payload.public.floorplan_classifications, (v) => {
			ret.push({ label: v.name, value: v.id })
		})
		return ret
	}

	render() {
		if (!this.props.payloadStatus) {
			return ""
		} else if (this.state.redirect) {
			return <Redirect to={this.state.redirectPath} />
		} else {
			let curFile = this.state.fields.plat_file ? (
				<a href={`${settings.s3}${this.state.fields.plat_file}`} className="small">
					{" "}
					View File
				</a>
			) : (
				""
			)
			return (
				<div>
					<Title title="Add Floorplan" showDate={false} />
					<div className="content">
						<h3 />
						<Formik
							enableReinitialize
							initialValues={this.state.fields}
							validationSchema={this.validation}
							validateOnMount={true}
							onSubmit={(values) => {
								this.props.loadingStatus(true)
								var user = localStorage.getItem("user")
								superagent
									.post(settings.ep + "/inputFloorplan")
									.set("Authorization", user)
									.send(values)
									.end((err, resp) => {
										if (err) {
											console.log(err)
											toast.error("Error inputting floorplan.  Please notify developers.")
											return
										}
										this.props.loadingStatus(false)
										toast.success(resp.body.message)
										this.setState(
											{
												redirect: true,
												redirectPath: resp.body.redirect,
											},
											() => {
												this.props.getPayload()
											}
										)
									})
							}}
							render={(f) => (
								<div className="addCommunity">
									<Form>
										{console.log(f)}
										<ul className="form__list">
											<li className={fieldStatus("name", f)}>
												<label htmlFor="name">
													Name <sup>*</sup>
												</label>
												{f.errors.name && f.touched.name && (
													<div className="form__message">{f.errors.name}</div>
												)}
												<Field name="name" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("plan_number", f)}>
												<label htmlFor="plan_number">Plan Number</label>
												{f.errors.plan_number && f.touched.plan_number && (
													<div className="form__message">{f.errors.plan_number}</div>
												)}
												<Field name="plan_number" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("builder", f, false, false, false)}>
												<label htmlFor="builder">
													Builder <sup>*</sup>
												</label>
												{f.errors.builder && f.touched.builder && (
													<div className="form__message">{f.errors.builder}</div>
												)}
												<ReactSelect
													name={`builder`}
													options={_.map(this.props.payload.public.builders, (v) => {
														return {
															label: v.name,
															value: v.id,
														}
													})}
													value={f.values.builder}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("sqft", f)}>
												<label htmlFor="sqft">
													Square Feet<sup>*</sup>
												</label>
												{f.errors.sqft && f.touched.sqft && (
													<div className="form__message">{f.errors.sqft}</div>
												)}
												<NumberField
													name="sqft"
													type="text"
													className="form__input"
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.sqft}
													error={f.errors.sqft}
													value={f.values.sqft}
													thousandSeparator={true}
												/>
											</li>
											{/* <li className={fieldStatus("price", f)}>
												<label htmlFor="price">
													Price <sup>*</sup>
												</label>
												{f.errors.price && f.touched.price && (
													<div className="form__message">{f.errors.price}</div>
												)}
												<NumberField
													name="price"
													type="text"
													className="form__input"
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.price}
													error={f.errors.price}
													value={f.values.price}
													thousandSeparator={true}
													prefix="$"
												/>
											</li> */}
											<li className={fieldStatus("stories", f)}>
												<label htmlFor="stories">
													Stories
												</label>
												{f.errors.stories && f.touched.stories && (
													<div className="form__message">{f.errors.stories}</div>
												)}
												<NumberField
													name="stories"
													type="text"
													className="form__input"
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.stories}
													error={f.errors.stories}
													value={f.values.stories}
													thousandSeparator={true}
												/>
											</li>
											<li className={fieldStatus("beds", f)}>
												<label htmlFor="beds">Beds</label>
												{f.errors.beds && f.touched.beds && (
													<div className="form__message">{f.errors.beds}</div>
												)}
												<NumberField
													name="beds"
													type="text"
													className="form__input"
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.beds}
													error={f.errors.beds}
													value={f.values.beds}
													thousandSeparator={true}
												/>
											</li>
											<li className={fieldStatus("full_baths", f)}>
												<label htmlFor="full_baths">Full Baths</label>
												{f.errors.full_baths && f.touched.full_baths && (
													<div className="form__message">{f.errors.full_baths}</div>
												)}
												<NumberField
													name="full_baths"
													type="text"
													className="form__input"
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.full_baths}
													error={f.errors.full_baths}
													value={f.values.full_baths}
													thousandSeparator={true}
												/>
											</li>
											<li className={fieldStatus("half_baths", f)}>
												<label htmlFor="half_baths">Half Baths</label>
												{f.errors.half_baths && f.touched.half_baths && (
													<div className="form__message">{f.errors.half_baths}</div>
												)}
												<NumberField
													name="half_baths"
													type="text"
													className="form__input"
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.half_baths}
													error={f.errors.half_baths}
													value={f.values.half_baths}
													thousandSeparator={true}
												/>
											</li>
											<li className={fieldStatus("garage", f)}>
												<label htmlFor="garage">
													Garage
												</label>
												{f.errors.garage && f.touched.garage && (
													<div className="form__message">{f.errors.garage}</div>
												)}
												<NumberField
													name="garage"
													type="text"
													className="form__input"
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.garage}
													error={f.errors.garage}
													value={f.values.garage}
													thousandSeparator={true}
												/>
											</li>
											<li className={fieldStatus("status", f, false, false, false)}>
												<label htmlFor="status">
													Status <sup>*</sup>
												</label>
												{f.errors.status && f.touched.status && (
													<div className="form__message">{f.errors.status}</div>
												)}
												<ReactSelect
													name={`status`}
													options={[
														{
															label: "Disabled",
															value: 0,
														},
														{
															label: "Enabled",
															value: 1,
														},
													]}
													value={f.values.status}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("properties", f)}>
												<label htmlFor="properties">
													Properties <sup>*</sup>
												</label>
												{f.errors.properties && f.touched.properties && (
													<div className="form__message">{f.errors.properties}</div>
												)}
												<ReactSelect
													name={`properties`}
													options={_.map(this.props.payload.public.properties, (v) => {
														return { label: v.name, value: v.id }
													})}
													isMulti
													value={f.values.properties}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("description", f)}>
												<label htmlFor="description">Description</label>
												{f.errors.description && f.touched.description && (
													<div className="form__message">{f.errors.description}</div>
												)}
												<TextArea
													name="description"
													className="form__textarea"
													value={f.values.description}
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.description}
													error={f.errors.description}
												/>
											</li>
											{this.props.payload.public.floorplan_classifications?.length ? (
												<li className={fieldStatus("classifications", f)}>
													<label htmlFor="classifications">Classifications</label>
													{f.errors.classifications && f.touched.classifications && (
														<div className="form__message">{f.errors.classifications}</div>
													)}
													<ReactSelect
														name={`classifications`}
														options={this.buildClassifications()}
														isMulti
														value={f.values.classifications}
														onBlur={f.setFieldTouched}
														onChange={f.setFieldValue}
													/>
												</li>
											) : null}
											<li className={fieldStatus("feed_name", f)}>
												<label htmlFor="feed_name">Feed Name</label>
												{f.errors.feed_name && f.touched.feed_name && (
													<div className="form__message">{f.errors.feed_name}</div>
												)}
												<Field name="feed_name" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("feed_name_secondary", f)}>
												<label htmlFor="feed_name_secondary">Feed Name Secondary</label>
												{f.errors.feed_name_secondary && f.touched.feed_name_secondary && (
													<div className="form__message">{f.errors.feed_name_secondary}</div>
												)}
												<Field name="feed_name_secondary" type="text" className="form__input" />
											</li>
											{settings.arc && (
												<>
													<li className={fieldStatus("similar", f, false, false, false)}>
														<label htmlFor="similar">Similar</label>
														{f.errors.similar && f.touched.similar && (
															<div className="form__message">{f.errors.similar}</div>
														)}
														<ReactSelect
															name={`similar`}
															options={_.map(
																this.props.payload.public.floorplans,
																(v) => {
																	return {
																		label: v.name,
																		value: v.id,
																	}
																}
															)}
															value={f.values.similar}
															onBlur={f.setFieldTouched}
															onChange={f.setFieldValue}
															isMulti
														/>
													</li>
													<li className={fieldStatus("max_pad_depth", f)}>
														<label htmlFor="max_pad_depth">Max Pad Depth</label>
														{f.errors.max_pad_depth && f.touched.max_pad_depth && (
															<div className="form__message">
																{f.errors.max_pad_depth}
															</div>
														)}
														<NumberField
															name="max_pad_depth"
															className="form__input"
															onChange={f.setFieldValue}
															onBlur={f.setFieldTouched}
															touched={f.touched.max_pad_depth}
															error={f.errors.max_pad_depth}
															value={f.values.max_pad_depth}
															thousandSeparator={true}
															float={true}
														/>
													</li>
													<li
														className={fieldStatus(
															"arc_review_notes",
															f,
															false,
															false,
															true
														)}>
														<label htmlFor="arc_review_notes">ARC Review Notes</label>
														{f.errors.arc_review_notes && f.touched.arc_review_notes && (
															<div className="form__message">
																{f.errors.arc_review_notes}
															</div>
														)}
														<TextArea
															name="arc_review_notes"
															className="form__textarea"
															value={f.values.arc_review_notes}
															onChange={f.setFieldValue}
															onBlur={f.setFieldTouched}
															touched={f.touched.arc_review_notes}
															error={f.errors.arc_review_notes}
														/>
													</li>
												</>
											)}
										</ul>
										<input type="submit" value="Submit" className={this.submitClasses(f.isValid)} />
									</Form>
								</div>
							)}
						/>
					</div>
				</div>
			)
		}
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getPayload,
			loadingStatus,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(AddFloorplan)
